<p-toolbar class="custom-toolbar">
  <ng-template #start>
    <app-filter-toolbar></app-filter-toolbar>
  </ng-template>
  <ng-template #center> </ng-template>
  <ng-template #end>
    <app-bottom-toolbar></app-bottom-toolbar>
    <app-common-bottom-toolbar class="margin-left"></app-common-bottom-toolbar>
  </ng-template>
</p-toolbar>
